var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99004 0C12.4134 0 16 3.58655 16 7.99004C16 12.4134 12.4134 16 7.99004 16C3.58655 16 0 12.4134 0 7.99004C0 3.58655 3.58655 0 7.99004 0ZM5.61893 4.78207L7.99004 7.15318L10.3811 4.78207C10.939 4.22416 11.7559 5.06102 11.2179 5.61893L8.8269 7.99004L11.2179 10.3811C11.7559 10.939 10.939 11.7559 10.3811 11.2179L7.99004 8.8269L5.61893 11.2179C5.06102 11.7559 4.22416 10.939 4.78207 10.3811L7.15318 7.99004L4.78207 5.61893C4.22416 5.06102 5.06102 4.22416 5.61893 4.78207Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.766a3996b6e79be9e8ef375db3851116.svg";
export { ForwardRef as ReactComponent };